/** Router component */
import React, { Component } from 'react';
import loadable from '@loadable/component';
import { Switch, Route, Redirect } from 'react-router-dom'
import { hot } from 'react-hot-loader/root';
import SecureRoute from './organism/secureRoute';
import PrivateRoute from '../services/router/privateRoute';
import PublicRoute from '../services/router/publicRoute';
import Cookie from '../lib/cookie';
import MFPage from './organism/investOnline/MFPage';
import AllPage from './organism/investOnline/AllPage';
import PMSPage from './organism/investOnline/PMSPage';
import ContactPage from './organism/investOnline/contactPage';
import LogoutPage from './organism/investOnline/LogoutPage';
const NoMatch = loadable(() => import('./pages/nomatch'));
const LoginForm = loadable(() => import('./pages/loginForm/login'));
const Dashboard = loadable(() => import('./pages/dashboard'));
const LoginFormAIF = loadable(() => import('./pages/loginFormAif/login'));
// const AifReport = loadable(() => import('./pages/aifReport'));
const PMSLogin = loadable(() => import('./pages/pmsLogin'));
// const Dashboard = loadable(() => import('./pages/dashboard'));
const pmsDashboard = loadable(() => import('./pages/pmsDashboard'));
const Report = loadable(() => import('./organism/dashboardContent/dashboard'));
const ThankYou = loadable(() => import('./pages/thankYou'));
const Feedback = loadable(() => import('./pages/feedback'));
const InavDashboard = loadable(() => import('./pages/inavdashboard'));

let cookie = new Cookie();

class Router extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disType: cookie.getCookie('distype'),
            silentLogin: cookie.getCookie('silentLogin')
        }
    }
    componentDidMount = () => {
        let disType = cookie.getCookie('distype')

    }
    render() {
        const userInfo = JSON.parse(localStorage.getItem('basicDetails'))?.role;
        console.log("this.state.disType", this.state.disType, userInfo);
        return (
            <Switch>
                <PublicRoute component={ThankYou} path="/thankyou" />
                {(this.state.disType !== undefined ?
                    <PrivateRoute restricted={true} component={Dashboard} path="/report" />
                    : <SecureRoute path="/report">
                        <Dashboard disType={this.state.disType} />
                    </SecureRoute>)}
                <PrivateRoute restricted={true} component={pmsDashboard} path="/Dashboard" />
                <PrivateRoute restricted={true} component={MFPage} path="/mfAuth" />
                <PrivateRoute restricted={true} component={AllPage} path="/allAuth" />
                <PrivateRoute restricted={true} component={PMSPage} path="/pmsAuth" />
                {/* <PrivateRoute restricted={true} component={ContactPage} path="/feedback" /> */}
                <PrivateRoute restricted={true} component={LogoutPage} path="/logoutDit" />
                <PrivateRoute restricted={true} component={Feedback} path="/feedback" />
                <PublicRoute component={InavDashboard} path="/inavdashboard" />

                <Route exact path="/">
                    < LoginForm />
                </Route>
                {/* <Route path="/dashboard">
                    <Dashboard />
                </Route> */}

                {((!this.state.disType || this.state.disType === undefined) && (!this.state.silentLogin || this.state.silentLogin === undefined)) ?
                    <>
                        <SecureRoute path="/raiseQuery">
                            <Dashboard />
                        </SecureRoute>
                        <SecureRoute path="/viewTab">
                            <Dashboard />
                        </SecureRoute>
                        <SecureRoute path="/admin">
                            <Dashboard />
                        </SecureRoute>
                    </>
                    : ""
                }

                <Route>
                    <NoMatch />
                </Route>
            </Switch>
        )
    }
}

export default process.env.NODE_ENV === "development" ? hot(Router) : Router;